
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Loading from 'vux/src/components/loading/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import LoadMore from 'vux/src/components/load-more/index.vue'

import global from '../../../static/js/global'
export default {
beforeMount(){
if(this.$router.history.current.path == "/momentslist"){
document.title = "邻里分享";
}
this.useragent = navigator.userAgent.toLowerCase().indexOf('iphone') > -1 ? true : false;
},
methods:{
reduce(){
let img = document.getElementById('bigpic');
if(this.current > 0){
this.current--;
}else{
this.current = 0;
}
this.imgsrc=this.list[this.index].imgs[this.current].maxPicUrl;
let self = this;
img.onload = function () {
self.top = (document.getElementById('view_01').clientHeight - this.height ) / 2;
$(this).animate({'opacity':+1},1,'swing');
}
},
add(){
if(this.current < this.list[this.index].imgs.length-1){
this.current++;
}else{
this.current = this.list[this.index].imgs.length-1;
}
let img = document.getElementById('bigpic');
this.imgsrc=this.list[this.index].imgs[this.current].maxPicUrl;
let self = this;
img.onload = function () {
self.top = (document.getElementById('view_01').clientHeight - this.height ) / 2;
$(this).animate({'opacity':+1},1,'swing');
}
},
viewBigPic(index,current){

this.preview = true;
this.current = current;
this.index = index;
let img = document.getElementById('bigpic');
let self = this;
img.onload = function () {
self.top = (document.getElementById('view_01').clientHeight - this.height ) / 2;
$(this).animate({'opacity':+1},2,'swing');
}
img.onerror = function () {
self.imgsrc = '../static/image/img_error.jpg';
}
this.imgsrc = this.list[this.index].imgs[this.current].maxPicUrl;
},
hideBigPic(){
this.preview = false;
},
like(index){
this.list[index].praisePoint += 1;
this.$http.get(global.host + 'themeShare/like?themeId='+this.list[index].themeId,{header:{Accept: "application/x-www-form-urlencoded"}}).then(function(res){
console.log(res);
},function(err){
console.log(err)
})
},
jumpto(){
this.$router.push({path:'/momentspublush',query:{communityId:this.$router.history.current.query.communityId,openid:this.$router.history.current.query.openid,phone:this.$router.history.current.query.phone,comnCode:this.$router.history.current.query.comnCode}})
},
changeRange(index){
this.index = index;
this.page = 1;
this.clearArray(this.list);
this.getData(this.page);
},
clearArray(arr){
let size = arr.length;
for(let i=0 ; i < size ; i++){
arr.pop();
}
},

getData(page,rows=5){
let data = {};
this.loading = true;
if(this.index == 0){
data = {'comnCode':this.$router.history.current.query.communityId,page:page,rows:rows}
}else{
data = {page:page,rows:rows}
}
let imgLoadMap = this.imgWrap;
this.$http.post(global.host + 'themeShare/findThemelist',data,{header:{Accept: "application/json; charset=utf-8"}}).then(function(res){
if(res.body.result){
let data = res.body.result;
for(let i = 0; i < data.length ; i++){
data[i].praisePoint = (isNaN(parseInt(data[i].praisePoint))? 0 : parseInt(data[i].praisePoint));
data[i].msgCount = (isNaN(parseInt(data[i].msgCount)) ? 0 : parseInt(data[i].msgCount));
if(data[i].imgs.length > 0){
for(let j = 0 ; j < data[i].imgs.length; j++){
data[i].imgs[j].maxPicUrl = global.baseImg + data[i].imgs[j].maxPicUrl;
data[i].imgs[j].minPicUrl = global.baseImg + data[i].imgs[j].minPicUrl;
let imgObj = new Image();
imgObj.src = data[i].imgs[j].maxPicUrl;
imgLoadMap.set(imgObj.src,imgObj);
}
}
this.list.push(data[i]);
}
}
this.loading = false;
},function(err){
console.log(err)
})
}
},
beforeMount(){
this.getData(this.page);
},
created(){
let self = this;
window.onscroll = function(){
let scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
let windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
let scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
if(scrollTop+windowHeight==scrollHeight){
if(!self.loading){
self.page +=1;
self.getData(self.page);
}
}
}
},
data(){
return{
titles:['本小区','全部',],
list:[],
imgWrap:new Map(),
index:0,
loading:false,
page:1,
phone:this.$router.history.current.query.phone,
preview:false,
imgsrc:'',
current:0,
top:0
}
},
components:{Tab, TabItem, XHeader,XImg,Flexbox, FlexboxItem,Loading,LoadMore},
directives: {TransferDom},
}



// WEBPACK FOOTER //
// ./src/components/momentsComponents/list.vue